import React from 'react';
import '../../styles/LandingFeaturedSeller.css';
import FeaturedSellerBg from '../../static/landing/landing-featured-seller-bg.png';

export default function LandingFeaturedSeller({ name, testimonial, sellerImg }) {
    return (
        <div className="LandingFeaturedSeller">
            <div className="bg-image"><img src={FeaturedSellerBg} alt="Featured seller background"/></div>
            <div className="bg-overlay"></div>
            <div className="featured-seller">
                <div className="featured-seller-header">
                    <h1>FEATURED SELLER</h1>
                    <h2>{`@${name}`}</h2>
                </div>
                <div className="featured-seller-info">
                    <div>
                        <p className="testimonial">
                            {testimonial}<br /><br/>
                            <span>{`@${name}`}</span>
                        </p>
                        <div className="featured-seller-img">
                            <img src={sellerImg} alt={`Featured seller @${name}`} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}